export default function handleCurrencyFormat(i18n, amount, currency, fraction) {
  const amountWithSign = Intl.NumberFormat(
    i18n.language,
    {
      currency: currency ?? 'EUR',
      style: 'currency',
      minimumFractionDigits: 2,
      maximumFractionDigits: fraction ?? 2,
    },
  ).format(
    amount,
  );

  return amountWithSign;
}
